import React from 'react'

function Service3() {
    return (
        <div>
            <h1>gUJARAT 3</h1>
        </div>
    )
}

export default Service3
